export const recommendationModalConstants = {
  SELECT_ALL: '__ALL__',
};